import { Component } from '@angular/core';
import { NavigationService } from 'netview';

@Component({
    selector: 'nav-menu',
	templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.scss']
})
export class NavMenuComponent {


	constructor(private navService: NavigationService) {

        return;
    }

}
